<template>
    <div
        class="compare-view__header pa-w-full pa-h-[32px] pa-flex pa-items-center pa-justify-center"
        :class="{
            'pa-bg-green-75 pa-text-green-600': isSourceColum,
            'pa-bg-gray-20 pa-text-gray-90': !isSourceColum,
        }"
    >
        <span>{{ compareTips }}</span>
        <button
            v-if="showSwitchButton"
            class="pa-ml-2 th-btn th-btn-sm th-btn-outline"
            @click="onChangeMode"
        >
            <svg width="16" height="16" class="th-btn-icon pa-mr-1">
                <use xlink:href="#SolidCompare" />
            </svg>
            <span>{{ t('patent-view.compareView.changeSource') }}</span>
        </button>
    </div>
</template>

<script setup lang="ts">
import { defineProps, withDefaults, computed, watch } from 'vue';
import { useI18n } from '@/composables/use-i18n';
import { useRoute, useRouter } from 'vue-router/composables';
import { useCompareUrlState, ERouterMode } from '@/composables/use-compare-url-state';
import { useCompareInit } from '@/composables/use-compare-init';
import '@patsnap-ui/icon/assets/solid/compare.svg'

const { t } = useI18n();
const {
    isSourcePatent,
    isSourceCustomText,
    isSourceCompareText,
    changeCompareMode,
} = useCompareUrlState();
const { isLoading:isCompareLoading } = useCompareInit();
const route = useRoute();
const router = useRouter();

const props = withDefaults(defineProps<{
    side: string;
}>(), {
    side: 'left',
})

const isSourceColum = computed(() => {
    return props.side === 'left';
})

const compareTips = computed(() => {
    return isSourceColum.value ? t('patent-view.compareView.sourceTips') : t('patent-view.compareView.targetTips');
})


// 只有处于文本对比 or 专利对比模式下，才显示按钮
const showSwitchButton = computed(() => {
    return !isCompareLoading.value && isSourceColum.value && (isSourcePatent.value || isSourceCustomText.value || isSourceCompareText.value);
})

const onChangeMode = () => {
    let mode = '';
    if (isSourcePatent.value) {
        mode = ERouterMode.EDIT_PATENT_ID;
    } else if (isSourceCustomText.value || isSourceCompareText.value) {
        mode = ERouterMode.EDIT_TEXT_ID;
    }
    changeCompareMode(mode);
}

</script>

<style lang="scss">

</style>
